import { User } from '../types';

export function isTechUser(user: User | null) {
  return !!user?.groups?.includes('Tech');
}
